import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M16.75 5a.7.7 0 0 0-.7.7v12.593a.7.7 0 1 0 1.4 0V5.7a.7.7 0 0 0-.7-.7m-9.983.2a.7.7 0 0 0-.024.99l5.54 5.814-5.54 5.813a.7.7 0 0 0 1.014.966l6-6.297a.7.7 0 0 0 0-.965l-6-6.297a.7.7 0 0 0-.99-.024"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
